import { useMutation } from '@tanstack/react-query';

import { generateAiDescription } from 'apis/offer-listing-service/api';

export type DescriptionType = 'original' | 'enhance' | 'formal' | 'playful';

export type GenerateDescriptionArgs = {
  targetLanguage: Language;
  info: string;
  type?: DescriptionType;
};

const promptTypeToPrompt: Record<DescriptionType, (originalDescription: string) => string> = {
  original: originalDescription => `Format better the original description ${originalDescription}`,
  enhance: originalDescription => `Enhance the original description: ${originalDescription}`,
  formal: originalDescription => `Generate a formal version of the original description: ${originalDescription}`,
  playful: originalDescription => `Generate a playful version of the original description: ${originalDescription}`,
};

export const useAiDescriptions = () => {
  return useMutation(['generateDescription'], ({ targetLanguage, info, type }: GenerateDescriptionArgs) => {
    const prompt = type ? promptTypeToPrompt[type](info) : info;

    return generateAiDescription(prompt, targetLanguage);
  });
};
